// Angular
import { Component } from '@angular/core';

// Composants
import { DialogBaseComponent } from 'src/app/@shared/components/abstract/dialog-base.component';
import { QrLoginComponent } from '../qr-login/qr-login.component';

@Component({
    selector: 'app-qr-login-dialog',
    imports: [QrLoginComponent],
    templateUrl: './qr-login-dialog.component.html',
    styleUrls: ['./qr-login-dialog.component.scss']
})
export class QrLoginDialogComponent extends DialogBaseComponent {}
